import React, { Component } from "react";
import TopHeader from "../Header/TopHeader";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { getDashboardDetails } from "../../constants/apiParams";
import { toast } from "react-toastify";
import { getUserID } from "../../util/utils";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";

import TeamStatisticsDashboard from "./TeamStatisticsDashboard";
import ThisQuarterInMyTeamDashboard from "./ThisQuarterInMyTeamDashboard";
import ThisMonthDashboard from "./ThisMonthDashboard";
import MyYearDashboard from "./MyYearDashboard"

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      teamStatistics: [],
      myYear: [],
      thisMonth: [],
      thisQuarterInMyTeam: [],
      selectedDate: "",
      date: new Date()
    };
  }

  componentDidMount() {
    this.setState(
      {
        selectedDate: this.getMonthDate(new Date())
      },
      () => {
        this.getDashboardDetails();
      }
    )
  }
  handleLoader = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  handleDashboardResponse = (data) => {
    this.setState({
      teamStatistics: data.team_statistics,
      myYear: data.my_year.sort((a, b) =>
        a.priority < b.priority ? 1 : b.priority < a.priority ? -1 : 0
      ),
      thisMonth: data.this_month,
      thisQuarterInMyTeam: data.this_quarter_in_my_team,
    });
  };

  getDashboardDetails = () => {
    const { selectedDate } = this.state;
    apiCall(
      METHOD.QUERY,
      getDashboardDetails(getUserID(), selectedDate),
      (data) => this.handleDashboardResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  getMonthDate = (date) => {
    const month = date.getUTCMonth() + 1; //months from 1-12
    const year = date.getUTCFullYear();
    return `${month}/${year}`;
  };


  handleColor = (result) => {
    if (result >= 100) {
      return "progress-bar bg-success";
    } else if (result >= 51 && result <= 99) {
      return "progress-bar bg-primary";
    } else if (result <= 50) {
      return "progress-bar bg-danger";
    }
  };

  handleFlagColor = (result) => {
    if (result >= 100) {
      return "fa fa-flag fa-fw text-success";
    } else if (result >= 51 && result <= 99) {
      return "fa fa-flag fa-fw text-primary";
    } else if (result <= 50) {
      return "fa fa-flag fa-fw text-danger";
    }
  };

  render() {
    const {
      teamStatistics,
      myYear,
      thisMonth,
      thisQuarterInMyTeam,
      date,
      isLoading
    } = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="content-wrapper">
              <TopHeader selectionType="0" />
              <div className="content">
                <div className="section section-padding">
                  <div className="container-fluid">
                    <div className="section-container">


                    {isLoading && (
                            <div className="loader-container">
                              <div className="loader-logo">
                                  <div className="sk-chase">
                                      <div className="sk-chase-dot"></div>
                                      <div className="sk-chase-dot"></div>
                                      <div className="sk-chase-dot"></div>
                                      <div className="sk-chase-dot"></div>
                                      <div className="sk-chase-dot"></div>
                                      <div className="sk-chase-dot"></div>
                                  </div>
                              </div>
                          </div>
                          )}
                      <form>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="row mb-4">
                              <div className="col-md-2">
                                <DatePicker
                                  selected={date}
                                  peekNextMonth
                                  locale={
                                    localStorage.getItem("i18nextLng") ?? "de"
                                  }
                                  showMonthYearPicker
                                  className="custom-select font-size-14"
                                  dateFormat="MMMM/yyyy"
                                  onChange={(date) => {
                                    const month = this.getMonthDate(date);
                                    this.setState({
                                      selectedDate: month,
                                      date,
                                    });
                                  }}
                                  dropdownMode="scroll"
                                />
                              </div>
                              <div className="col-md-2">
                                <button
                                  type="button"
                                  onClick={() => this.getDashboardDetails()}
                                  className="btn btn-primary btn-sm pb-1"
                                >
                                  {t("timeStatistic.submit")}
                                </button>
                              </div>
                            </div>
                          </div>
                          <TeamStatisticsDashboard teamStatistics={teamStatistics} handleColor={this.handleColor}/>
                          <MyYearDashboard myYear={myYear} handleColor={this.handleColor} handleFlagColor={this.handleFlagColor}/>
                          <ThisMonthDashboard thisMonth={thisMonth} myYear={myYear}/>
                          <ThisQuarterInMyTeamDashboard thisQuarterInMyTeam={thisQuarterInMyTeam} myYear={myYear}/>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(Dashboard));
